export default __webpack_public_path__ + "static/media/calendar.def3ad7f.svg";